export const SET_LOADING_DATA = '@order/SET_LOADING_DATA';
export const SET_LOADING_PRODUCT_DATA = '@order/SET_LOADING_PRODUCT_DATA';
export const SET_LOADING_SEND = '@order/SET_LOADING_SEND';
export const SET_LOADING_SELECTS = '@order/SET_LOADING_SELECTS';
export const SET_LOADING_VINCULATED_ORDER = '@order/SET_LOADING_VINCULATED_ORDER';

export const SET_SHOW_MODAL_PRODUCT_DETAIL = '@order/SET_SHOW_MODAL_PRODUCT_DETAIL';
export const SET_SHOW_MODAL_PRODUCT_REQUEST = '@order/SET_SHOW_MODAL_PRODUCT_REQUEST';
export const SET_SHOW_MODAL_PRODUCT_VARIANT = '@order/SET_SHOW_MODAL_PRODUCT_VARIANT';
export const SET_HIDE_CART_RECOMMENDATIONS = '@order/SET_HIDE_CART_RECOMMENDATIONS';

export const SET_SHOW_MODAL_ORDER = '@order/SET_SHOW_MODAL_ORDER';
export const UPDATE_MODAL_ORDER = '@order/UPDATE_MODAL_ORDER';

export const SET_SHOW_MODAL_REASON = '@order/SET_SHOW_MODAL_REASON';
export const VALIDATE_PASSWORD_MODAL_REASON = '@order/VALIDATE_PASSWORD_MODAL_REASON';

//FORM
export const INITIALIZE_REQUEST = '@order/INITIALIZE_REQUEST';
export const INITIALIZE_SUCCESS = '@order/INITIALIZE_SUCCESS';

export const SET_CLIENT_REQUEST = '@order/SET_CLIENT_REQUEST';
export const SET_CLIENT_SUCCESS = '@order/SET_CLIENT_SUCCESS';

export const UPDATE_ORDER = '@order/UPDATE_ORDER';
export const UPDATE_SELECTS = '@order/UPDATE_SELECTS';

export const SET_ORDER_TYPE_REQUEST = '@order/SET_ORDER_TYPE_REQUEST';
export const SET_ORDER_TYPE_SUCCESS = '@order/SET_ORDER_TYPE_SUCCESS';

export const GET_ALTERNATIVE_PRODUCT_REQUEST = '@order/GET_ALTERNATIVE_PRODUCT_REQUEST';
export const GET_ALTERNATIVE_PRODUCT_SUCCESS = '@order/GET_ALTERNATIVE_PRODUCT_SUCCESS';

export const ADD_PRODUCT_CART_REQUEST = '@order/ADD_PRODUCT_CART_REQUEST';
export const ADD_PRODUCT_CART_SUCCESS = '@order/ADD_PRODUCT_CART_SUCCESS';

export const LOAD_PRODUCT_REQUEST = '@order/LOAD_PRODUCT_REQUEST';
export const LOAD_PRODUCT_SUCCESS = '@order/LOAD_PRODUCT_SUCCESS';

export const UPDATE_PRODUCT_REQUEST = '@order/UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = '@order/UPDATE_PRODUCT_SUCCESS';

export const UPDATE_QUANTITY_REQUEST = '@order/UPDATE_QUANTITY_REQUEST';
export const UPDATE_QUANTITY_SUCCESS = '@order/UPDATE_QUANTITY_SUCCESS';

export const SET_PRODUCT_COMPLEMENT = '@order/SET_PRODUCT_COMPLEMENT';

export const UPDATE_ORDER_MARGIN = '@order/UPDATE_ORDER_MARGIN';

export const UPDATE_QUANTITY_TOTAL_UNIT_REQUEST = '@order/UPDATE_QUANTITY_TOTAL_UNIT_REQUEST';

export const CHECK_QUANTITY_MULTIPLE = '@order/CHECK_QUANTITY_MULTIPLE';

export const UPDATE_SOLDPRICE_REQUEST = '@order/UPDATE_SOLDPRICE_REQUEST';

export const UPDATE_UNITARY_VALUE_REQUEST = '@order/UPDATE_UNITARY_VALUE_REQUEST';

export const UPDATE_DISCOUNT_REQUEST = '@order/UPDATE_DISCOUNT_REQUEST';

export const SET_PRODUCT_PACKING = '@order/SET_PRODUCT_PACKING';

export const SET_ASSISTED_SALE_TYPE = '@order/SET_ASSISTED_SALE_TYPE';

export const SET_PRODUCT_PROMOTION = '@order/SET_PRODUCT_PROMOTION';
export const SET_SHOW_MODAL_PRODUCT_PROMOTION_KIT = '@order/SET_SHOW_MODAL_PRODUCT_PROMOTION_KIT';
export const GET_PRODUCT_PROMOTION_KIT_REQUEST = '@order/GET_PRODUCT_PROMOTION_KIT_REQUEST';
export const ADD_PROMOTION_KIT_REQUEST = '@order/ADD_PROMOTION_KIT_REQUEST';
export const UPDATE_PROMOTION_KIT_REQUEST = '@order/UPDATE_PROMOTION_KIT_REQUEST';

export const GET_PROMOTION_KIT_LIST_REQUEST = '@order/GET_PROMOTION_KIT_LIST_REQUEST';
export const GET_PROMOTION_KIT_LIST_SUCESS = '@order/GET_PROMOTION_KIT_LIST_SUCESS';

export const SET_BONIFICATED_REQUEST = '@order/SET_BONIFICATED_REQUEST';
export const SET_ORDER_TYPE_BONIFICATED_REQUEST = '@order/SET_ORDER_TYPE_BONIFICATED_REQUEST';

export const REMOVE_PRODUCT_CART_REQUEST = '@order/REMOVE_PRODUCT_CART_REQUEST';
export const REMOVE_PRODUCT_CART_SUCCESS = '@order/REMOVE_PRODUCT_CART_SUCCESS';

export const CLEAR_ORDER = '@order/CLEAR_ORDER';
export const CLEAR_ALL_CART = '@order/CLEAR_ALL_CART';
export const CLEAR_ORDER_ITEM = '@order/CLEAR_ORDER_ITEM';

export const SET_SHIPPING_TYPE_REQUEST = '@order/SET_SHIPPING_TYPE_REQUEST';
export const SET_SHIPPING_FEE_REQUEST = '@order/SET_SHIPPING_FEE_REQUEST';
export const SET_SHIPPING_TYPE_SUCCESS = '@order/SET_SHIPPING_TYPE_SUCCESS';

export const GET_SHIPPING_REQUEST = '@order/GET_SHIPPING_REQUEST';
export const GET_SHIPPING_SUCCESS = '@order/GET_SHIPPING_SUCCESS';

export const SPLIT_ORDER_VALIDATION_REQUEST = '@order/SPLIT_ORDER_VALIDATION_REQUEST';
export const SPLIT_ORDER_VALIDATION_SUCCESS = '@order/SPLIT_ORDER_VALIDATION_SUCCESS';

export const SET_SUBSIDIARY_REQUEST = '@order/SET_SUBSIDIARY_REQUEST';
export const SET_SUBSIDIARY_SUCCESS = '@order/SET_SUBSIDIARY_SUCCESS';

export const SET_SUBSIDIARY_STOCK_REQUEST = '@order/SET_SUBSIDIARY_STOCK_REQUEST';
export const SET_SUBSIDIARY_STOCK_SUCCESS = '@order/SET_SUBSIDIARY_STOCK_SUCCESS';

export const SET_PAYMENT_OPTION_REQUEST = '@order/SET_PAYMENT_OPTION_REQUEST';
export const SET_PAYMENT_OPTION_SUCCESS = '@order/SET_PAYMENT_OPTION_SUCCESS';

export const SET_PAYMENT_PLAN_REQUEST = '@order/SET_PAYMENT_PLAN_REQUEST';
export const SET_PAYMENT_PLAN_SUCCESS = '@order/SET_PAYMENT_PLAN_SUCCESS';

export const SET_PAYMENT_PLAN_GROUP_REQUEST = '@order/SET_PAYMENT_PLAN_GROUP_REQUEST';
export const SET_PAYMENT_PLAN_GROUP_SUCCESS = '@order/SET_PAYMENT_PLAN_GROUP_SUCCESS';

export const SET_PAYMENT_PLAN_GROUP_ETHICAL = '@order/SET_PAYMENT_PLAN_GROUP_ETHICAL';
export const SET_PAYMENT_PLAN_GROUP_GENERIC = '@order/SET_PAYMENT_PLAN_GROUP_GENERIC';

export const SET_LOAD_TYPE_REQUEST = '@order/SET_LOAD_TYPE_REQUEST';
export const SET_LOAD_TYPE_SUCCESS = '@order/SET_LOAD_TYPE_SUCCESS';

export const SET_BONIFICATION_TYPE_REQUEST = '@order/SET_BONIFICATION_TYPE_REQUEST';

export const SET_VARIABLE_PAYMENT_REQUEST = '@order/SET_VARIABLE_PAYMENT_REQUEST';
export const SET_VARIABLE_PAYMENT_SUCCESS = '@order/SET_VARIABLE_PAYMENT_SUCCESS';

export const STORE_PERCENTUAL_RATE = '@order/STORE_PERCENTUAL_RATE';
export const STORE_ORDER_INFOS = '@order/STORE_ORDER_INFOS';

export const VALIDATE_ORDER_REQUEST = '@order/VALIDATE_ORDER_REQUEST';
export const VALIDATE_ORDER_SUCCESS = '@order/VALIDATE_ORDER_SUCCESS';

export const SET_OPEN_MODAL_BONIFICATION = '@order/SET_OPEN_MODAL_BONIFICATION';
export const SET_ORDER_BONIFICATION_REQUEST = '@order/SET_ORDER_BONIFICATION_REQUEST';
export const SET_ORDER_BONIFICATION_SUCCESS = '@order/SET_ORDER_BONIFICATION_SUCCESS';

export const SET_BUDGET = '@order/SET_BUDGET';

export const SET_DELIVERY_ADDRESS_CODE = '@order/SET_DELIVERY_ADDRESS_CODE';

export const SET_ESTIMATED_DELIVERY_DATE = '@order/SET_ESTIMATED_DELIVERY_DATE';

export const SET_BILLING_DATE = '@order/SET_BILLING_DATE';

export const SET_ORDER_NUMBER = '@order/SET_ORDER_NUMBER';

export const SET_SOME_OBSERVATION = '@order/SET_SOME_OBSERVATION';

export const SET_SEND_PDF_INFO = '@order/SET_SEND_PDF_INFO';

export const DOWNLOAD_EXCEL = '@order/DOWNLOAD_EXCEL';

export const SET_BONIFICATION_BOUND = '@order/SET_BONIFICATION_BOUND';

export const SET_DEFAULT_DELIVERY = '@order/SET_DEFAULT_DELIVERY';

export const SET_SHIPPING_DELIVERY_PROVIDER = '@order/SET_SHIPPING_DELIVERY_PROVIDER';

export const SEND_ORDER = '@order/SEND_ORDER';

export const SHARE_PDF = '@order/SHARE_PDF';

export const CANCEL_ORDER_TOTVS = '@order/CANCEL_ORDER_TOTVS';
export const SET_VENDOR = '@order/SET_VENDOR';

//LIST
export const GET_ALL_REQUEST = '@order/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@order/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@order/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@order/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@order/SAVE_REQUEST';
export const SAVE_SUCCESS = '@order/SAVE_SUCCESS';

export const DELETE_OR_CANCEL_ITEM = '@order/DELETE_OR_CANCEL_ITEM';
export const EDIT_ITEM = '@order/EDIT_ITEM';
export const RESEND_ITEM = '@order/RESEND_ITEM';

export const SEARCH = '@order/SEARCH';
export const GET_ALL_FILTER_SELECTS_REQUEST = '@order/GET_ALL_FILTER_SELECTS_REQUEST';
export const GET_ALL_FILTER_SELECTS_SUCCESS = '@order/GET_ALL_FILTER_SELECTS_SUCCESS';

export const SET_PAGE = '@order/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@order/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@order/SET_ORDER';
export const SET_ORDERBY = '@order/SET_ORDEBY';

export const SET_SUBSIDIARY_STOCK_RESTRICTIONS_REQUEST = '@order/SET_SUBSIDIARY_STOCK_RESTRICTIONS_REQUEST';
export const SET_SUBSIDIARY_STOCK_RESTRICTIONS = '@order/SET_SUBSIDIARY_STOCK_RESTRICTIONS';

export const APPLY_DISCOUNT_TO_ALL_ITEMS_REQUEST = '@order/APPLY_DISCOUNT_TO_ALL_ITEMS_REQUEST';
export const APPLY_DISCOUNT_TO_ALL_ITEMS_SUCCESS = '@order/APPLY_DISCOUNT_TO_ALL_ITEMS_SUCCESS';
export const CALCULATE_BALANCE_REQUEST = '@order/CALCULATE_BALANCE_REQUEST';
export const UPDATE_BALANCE_SUCCESS = '@order/UPDATE_BALANCE_SUCCESS';
export const UPDATE_ORDER_OTHER_EXPENSES = '@order/UPDATE_ORDER_OTHER_EXPENSES';

export const GET_RESTRICTIONS_REQUEST = '@order/GET_RESTRICTIONS_REQUEST';

export const SET_SUBSIDIARY_PRODUCT_STOCK_REQUEST = '@order/SET_SUBSIDIARY_PRODUCT_STOCK_REQUEST';
export const SET_SUBSIDIARY_PRODUCT_STOCK_SUCCESS = '@order/SET_SUBSIDIARY_PRODUCT_STOCK_SUCCESS';

export const ORDER_TYPE_SEND = {
  BUDGET: 'budget',
  LOAD: 'load',
  ORDER: 'order',
  PAYMENT_LINK: 'payment_link',
  WAITING_APPROVAL: 'waiting_approval'
};

export const ORDER_STATUS = {
  ACCEPTED: 'accepted',
  AVAILABLE: 'available',
  BILLED: 'billed',
  BUDGET: 'budget',
  BLOCKED: 'blocked',
  BUDGET_ERP: 'budgetERP',
  CANCELED: 'canceled',
  DELIVERED: 'delivered',
  ERROR: 'error',
  LOADED: 'loaded',
  MOUNTED: 'mounted',
  ON_DELIVERY: 'onDelivery',
  PAID: 'paid',
  PARTIAL_BILLED: 'partialBilled',
  PENDING: 'pending',
  PROCESSING: 'processing',
  REJECTED: 'rejected',
  RELEASED: 'released',
  SINCRONIZED: 'sincronized',
  WAITING_ERP: 'waitingERP',
  WAITING_PAYMENT: 'waitingPayment',
  PARTIAL_RELEASED: 'partialReleased',
  PARTIAL_STOCK: 'inPartialStock',
  STOCK: 'inStock',
  WAITING_PARTIAL_BILLING: 'waitingPartialBilling',
  WAITING_BILLING: 'waitingBilling',
  CANCELED_ITEM: 'canceledItem',
  CANCELED_MINIMUM_VALUE: 'canceledMinimumValue',
  CANCELED_SUPERVISOR: 'canceledSupervisor',
  CANCELED_WEB: 'canceledWeb',
  WAITING_APPROVAL: 'waitingApproval',
  WAITING_LOAD: 'waitingLoad',
  BONIFICATION: 'bonification',
  CANCELED_BUDGET: 'canceledBudget',
  ORIGINAL_SPLIT: 'originalSplit',
  RETURNED: 'returned',
  AWAITING_SYNC: 'awaitingSync'
};

export const ORDER_TYPES = {
  NORMAL: 'normal',
  BONIFICATION: 'bonification',
  COLLECT: 'collect',
  FUTURE_SALE: 'futureSale',
  DELIVERY_PRE_ORER: 'deliveryPreOrder',
  WAITING_PAYMENT: 'waitingPayment'
};
